import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BonusLedgerEntry } from 'src/app/models/bonus-ledger.model';
import { AuthService } from 'src/app/services/auth.service';
import { BonusHistoryService } from 'src/app/services/bonus-history.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-bonus-history',
  templateUrl: './bonus-history.component.html',
  styleUrls: ['./bonus-history.component.scss'],
})
export class BonusHistoryComponent implements OnInit {
  history: BonusLedgerEntry[] = [];

  constructor(
    private ledgerServ: BonusHistoryService,
    public authServ: AuthService,
    public dataServ: DataService,
    private mdlctrl: ModalController
  ) {}

  async ngOnInit() {
    if (!this.authServ.profile) {
      await this.authServ.getMe();
    }

    this.history = await this.ledgerServ.getBonusHistory(
      this.authServ.profile.id
    );
  }

  async close() {
    await this.mdlctrl.dismiss();
  }
}
